import React, { useCallback, useEffect, useState } from 'react';
import './CardsCantidad.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage, faList, faRectangleList, faTag, faUser } from '@fortawesome/free-solid-svg-icons';
import { faProductHunt } from '@fortawesome/free-brands-svg-icons';
import { Link as Anchor } from "react-router-dom";
import baseURL from '../../url';
import { fetchUsuario, getUsuario } from '../../user';

const EMPTY_COUNTS = {
    usuarios: 0,
    productos: 0,
    banners: 0,
    categorias: 0,
    codigos: 0,
    pedidos: 0,
};

const DASHBOARD_CARDS = [
    { key: 'usuarios', label: 'Usuarios', icon: faUser, link: '/dashboard/usuarios' },
    { key: 'productos', label: 'Productos', icon: faProductHunt, link: '/dashboard/productos' },
    { key: 'banners', label: 'Banners', icon: faImage, link: '/dashboard/banners' },
    { key: 'categorias', label: 'Categorias', icon: faList, link: '/dashboard/categorias' },
    { key: 'codigos', label: 'Promociones', icon: faTag, link: '/dashboard/promociones' },
    { key: 'pedidos', label: 'Pedidos', icon: faRectangleList, link: '/dashboard/pedidos' },
];

const COLLABORATOR_CARDS = DASHBOARD_CARDS.filter(card =>
    ['productos', 'categorias', 'pedidos'].includes(card.key)
);

const FALLBACK_ENDPOINTS = [
    { key: 'usuarios', endpoint: 'usuariosGet.php', responseKey: 'usuarios' },
    { key: 'productos', endpoint: 'productosGet.php', responseKey: 'productos' },
    { key: 'banners', endpoint: 'bannersGet.php', responseKey: 'banner' },
    { key: 'categorias', endpoint: 'categoriasGet.php', responseKey: 'categorias' },
    { key: 'codigos', endpoint: 'codigosGet.php', responseKey: 'codigos' },
    { key: 'pedidos', endpoint: 'pedidoGet.php', responseKey: 'pedidos' },
];

export default function CardsCantidad() {
    const [conteos, setConteos] = useState(EMPTY_COUNTS);
    const [loading, setLoading] = useState(true);

    const cargarConteosDesdeListas = useCallback(async () => {
        const resultados = { ...EMPTY_COUNTS };
        const respuestas = await Promise.allSettled(
            FALLBACK_ENDPOINTS.map(item =>
                fetch(`${baseURL}/${item.endpoint}`, { method: 'GET' })
                    .then(response => response.json())
                    .then(data => ({
                        key: item.key,
                        total: Array.isArray(data?.[item.responseKey]) ? data[item.responseKey].length : 0,
                    }))
            )
        );

        respuestas.forEach(resultado => {
            if (resultado.status === 'fulfilled') {
                resultados[resultado.value.key] = resultado.value.total;
            }
        });

        setConteos(resultados);
    }, []);

    const cargarConteos = useCallback(async () => {
        try {
            const response = await fetch(`${baseURL}/dashboardCountsGet.php`, {
                method: 'GET',
            });
            const data = await response.json();

            if (!response.ok || data.error || !data.conteos) {
                throw new Error(data.error || 'No se pudieron cargar los conteos.');
            }

            setConteos({
                ...EMPTY_COUNTS,
                ...data.conteos,
            });
        } catch (error) {
            cargarConteosDesdeListas();
        }
    }, [cargarConteosDesdeListas]);

    useEffect(() => {
        cargarConteos();
    }, [cargarConteos]);

    useEffect(() => {
        const fetchData = async () => {
            await fetchUsuario();
            setLoading(false);
        };

        fetchData();
    }, []);

    const renderCard = (card, compact = false) => (
        <Anchor to={card.link} className='cardCantidad' id={compact ? 'cardCantidad2' : undefined} key={card.key}>
            <FontAwesomeIcon icon={card.icon} className='icons' />
            <div className='deColumn'>
                <h3>{card.label}</h3>
                <h2>{Number(conteos[card.key] || 0).toLocaleString('es-CO')}</h2>
            </div>
        </Anchor>
    );

    const usuarioLegued = getUsuario();

    return (
        <div className='CardsCantidad'>
            {loading ? (
                <></>
            ) : usuarioLegued?.idUsuario ? (
                <>
                    {usuarioLegued?.rol === 'admin' ? (
                        DASHBOARD_CARDS.map(card => renderCard(card))
                    ) : usuarioLegued?.rol === 'colaborador' ? (
                        COLLABORATOR_CARDS.map(card => renderCard(card, true))
                    ) : (
                        <></>
                    )}
                </>
            ) : (
                DASHBOARD_CARDS.map(card => renderCard(card))
            )}
        </div>
    );
}
